import { usePrefsStore } from '../store/prefsStore'
import { encodeState, SHARE_PARAM } from '../utils/mapSharing'
import '../styles/MapContextMenu.css'

const toDMS = (v, pos, neg) => {
  const hemi = v >= 0 ? pos : neg
  const abs = Math.abs(v); const d = Math.floor(abs)
  const mf = (abs - d) * 60; const m = Math.floor(mf); const s = ((mf - m) * 60).toFixed(1)
  return `${d}°${String(m).padStart(2, '0')}'${s}"${hemi}`
}

const formatCoords = (lng, lat, fmt) => fmt === 'DMS'
  ? `${toDMS(lat, 'N', 'S')} ${toDMS(lng, 'E', 'W')}`
  : `${lat.toFixed(5)}, ${lng.toFixed(5)}`

// Context menu on right-click: copy the coordinates, or copy a link that
// recenters the map on this position (reuses the ?s= full-state restore).
export default function MapContextMenu({ menu, onClose, map, showToast }) {
  const coordFormat = usePrefsStore((s) => s.coordFormat)
  if (!menu) return null

  const copyCoords = () => {
    const text = formatCoords(menu.lng, menu.lat, coordFormat)
    navigator.clipboard.writeText(text)
      .then(() => showToast?.('Coordonnées copiées', 'success'))
      .catch(() => window.prompt('Coordonnées :', text))
    onClose()
  }

  const sharePosition = () => {
    const zoom = map.current ? Math.max(map.current.getZoom(), 5) : 6
    const url = `${window.location.origin}${window.location.pathname}?${SHARE_PARAM}=${encodeState({ v: 1, c: [+menu.lng.toFixed(5), +menu.lat.toFixed(5)], z: +zoom.toFixed(2), b: 0 })}`
    navigator.clipboard.writeText(url)
      .then(() => showToast?.('Lien de la position copié', 'success'))
      .catch(() => window.prompt('Lien :', url))
    onClose()
  }

  return (
    <>
      <div className="map-context-backdrop" onClick={onClose} onContextMenu={(e) => { e.preventDefault(); onClose() }} />
      <div className="map-context-menu pr-widget" style={{ left: menu.x, top: menu.y }}>
        <div className="map-context-coords">{formatCoords(menu.lng, menu.lat, coordFormat)}</div>
        <button type="button" onClick={copyCoords}>📋 Copier les coordonnées</button>
        <button type="button" onClick={sharePosition}>🔗 Partager cette position</button>
      </div>
    </>
  )
}
